import dynamic from 'next/dynamic';

const KycVerificationDynamic = dynamic(
  async () => import('./index').then((m) => m.KycVerification),
  {
    ssr: false,
    loading: () => null,
  }
);

export { KycVerificationDynamic };
